import { AppRoutes } from '@/i18n/constants';

export const isGamificationAllowedByEnvironment = () => true;

const getPathWithoutLocale = (pathname: string) => pathname.replace(/^\/[a-z]{2}(?=\/|$)/, '') || pathname;

export const isGamificationRouteBlocked = (pathname: string) => {
  const pathWithoutLocale = getPathWithoutLocale(pathname);

  return pathWithoutLocale.startsWith(AppRoutes.gamification) && !isGamificationAllowedByEnvironment();
};
